export default __webpack_public_path__ + "static/media/properties-icon.22d36339.svg";